export const translations = {
  es: {
    nav: {
      inicio: "Portada",
      perfil: "Perfil",
      estadisticas: "Estadísticas",
      analisis: "Análisis",
      videos: "Vídeos",
      galeria: "Galería",
      mercado: "Mercado",
      contacto: "Contacto",
      menu: "Menú",
    },
    hero: {
      eyebrow: "Perfil oficial del jugador",
      name1: "CRISTIÁN",
      name2: "DÍAZ FERRADA",
      subtitle:
        "Defensa central · Mediocampista defensivo · Deportes Antofagasta · Chile",
      quote:
        "Defensor versátil, intenso y con capacidad para competir en más de una posición.",
      ctaProfile: "Ver perfil",
      ctaStats: "Estadísticas",
      ctaVideos: "Vídeos",
      contract: "Contrato hasta el 31 de diciembre de 2026",
      freeAgent: "Disponible como agente libre desde enero de 2027",
      rankingBadge: "N.º 1 central · Liga de Ascenso 2026 · Data Ficus",
    },
    marquee: [
      "Defensa central",
      "Mediocampista defensivo",
      "Deportes Antofagasta",
      "Chile",
      "23 años",
      "1,86 m",
    ],
    profile: {
      eyebrow: "01 · Perfil",
      title: "Perfil",
      description:
        "Defensor con experiencia en el fútbol profesional chileno, capacidad para defender el área y anticipar, y versatilidad para actuar por delante de la defensa.",
      facts: {
        age: "Edad",
        nationality: "Nacionalidad",
        height: "Estatura",
        foot: "Pie hábil",
        positions: "Posiciones",
        club: "Club actual",
      },
      values: {
        age: "23 años",
        nationality: "Chilena",
        height: "1,86 m",
        foot: "Derecho",
        positions: "Defensa central · Mediocampista defensivo",
        club: "Deportes Antofagasta",
      },
    },
    stats: {
      eyebrow: "02 · Estadísticas",
      title: "Estadísticas 2026",
      matches: "Partidos",
      minutes: "Minutos",
      goals: "Goles",
      interceptions: "Intercepciones",
      blockedShots: "Remates interceptados",
      defenseTitle: "Registro defensivo · Liga 2026",
      speedTitle: "Velocidad máxima en partido",
      speedValue: "+34 km/h",
      agencyBadge: "Dato de la representación",
      tableTitle: "Detalle por competición",
      table: {
        competition: "Competición",
        season: "Temporada",
        matches: "PJ",
        minutes: "Min",
        goals: "Goles",
        total: "Total 2026",
        noData: "—",
      },
      careerLabel: "Carrera profesional en Deportes Antofagasta (todas las competiciones · Transfermarkt, 12/10/2026)",
      noteCutoff: "Fecha de corte",
      noteSource: "Fuente",
      noteDisclaimer:
        "Partidos, minutos y goles según la fuente indicada; pueden variar tras cada jornada. Las métricas defensivas proceden del informe de la representación (IKONS) y se muestran con su propia fecha de corte.",
      noteLink: "Ver datos de rendimiento",
    },
    analysis: {
      eyebrow: "03 · Análisis",
      title: "Análisis de perfil",
      recognitionLabel: "Reconocimiento",
      recognitionTitle: "Mejor central de la Liga de Ascenso 2026",
      recognitionScore: "Valoración",
      recognitionMinutes: "% de minutos",
      recognitionSource: "Fuente",
      recognitionPublished: "Publicado",
      recognitionView: "Ver ranking completo",
      recognitionImgAlt:
        "Ranking Top 10 mejores centrales de la Liga de Ascenso Chile 2026 de Data Ficus, con Cristian Díaz en primera posición",
      factLabel: "Hecho",
      viewLabel: "Valoración",
      items: [
        {
          title: "Versatilidad",
          tag: "Central · Mediocampista",
          fact: "Compite como defensa central y como mediocampista defensivo.",
          view: "Dos posiciones en un mismo jugador.",
        },
        {
          title: "Anticipación e intercepciones",
          tag: "Lectura de juego",
          fact: "38 intercepciones y 13 remates interceptados en Liga 2026 (informe IKONS, corte junio 2026). Sofascore señala la intercepción de balón y el posicionamiento como fortalezas de su perfil.",
          view: "Corte de líneas de pase y protección del área.",
        },
        {
          title: "Velocidad",
          tag: "+34 km/h",
          fact: "Velocidad máxima superior a 34 km/h en partido, según dato reportado por la representación.",
          view: "Capacidad para cubrir espacios largos.",
        },
      ],
    },
    videos: {
      eyebrow: "04 · Vídeos",
      title: "Vídeos",
      play: "Reproducir vídeo",
      close: "Cerrar vídeo",
      note: "Material exclusivo. Los vídeos se reproducen únicamente dentro de este sitio.",
    },
    gallery: {
      eyebrow: "05 · Galería",
      title: "Galería",
      note: "Material de partido y entrenamiento. Los pies de foto se añadirán cuando se confirme el rival, la competición y la fecha de cada imagen.",
    },
    market: {
      eyebrow: "06 · Mercado",
      title: "Valoración y situación de mercado",
      valueLabel: "Valor de mercado estimado",
      disclaimer:
        "Estimación pública de Transfermarkt; última actualización indicada: 22/06/2026. No equivale a una oferta, cláusula ni precio de traspaso.",
      sourceLink: "Ver fuente en Transfermarkt",
      contractTitle: "Situación contractual",
      contract: "Contrato hasta el 31/12/2026",
      freeAgent: "Agente libre desde enero de 2027",
    },
    contact: {
      eyebrow: "07 · Contacto",
      title: "Contacto profesional",
      lead: "Consultas de clubes, directores deportivos, entrenadores y scouts. Representación: IKONS.",
      directLabel: "Contacto directo IKONS",
      formTitle: "Enviar consulta",
      name: "Nombre",
      club: "Club",
      role: "Cargo",
      email: "Correo",
      message: "Mensaje",
      namePh: "Nombre y apellidos",
      clubPh: "Club u organización",
      rolePh: "Director deportivo, scout, entrenador…",
      emailPh: "nombre@club.com",
      messagePh: "Escribe tu consulta profesional",
      submit: "Enviar mensaje",
      sending: "Enviando…",
      success: "Mensaje enviado. IKONS responderá a la mayor brevedad.",
      error: "No se pudo enviar. Inténtalo de nuevo o escribe al correo directo.",
    },
    footer: {
      managed:
        "Sitio gestionado por IKONS · Representación de Cristián Antonio Díaz Ferrada",
      updated: "Actualizado",
      rights: "Contenido de uso profesional.",
    },
  },
  en: {
    nav: {
      inicio: "Home",
      perfil: "Profile",
      estadisticas: "Stats",
      analisis: "Analysis",
      videos: "Videos",
      galeria: "Gallery",
      mercado: "Market",
      contacto: "Contact",
      menu: "Menu",
    },
    hero: {
      eyebrow: "Official player profile",
      name1: "CRISTIÁN",
      name2: "DÍAZ FERRADA",
      subtitle:
        "Centre-back · Defensive midfielder · Deportes Antofagasta · Chile",
      quote:
        "A versatile, intense defender with the ability to compete in more than one position.",
      ctaProfile: "View profile",
      ctaStats: "Stats",
      ctaVideos: "Videos",
      contract: "Contract until 31 December 2026",
      freeAgent: "Available as a free agent from January 2027",
      rankingBadge: "No. 1 centre-back · Liga de Ascenso 2026 · Data Ficus",
    },
    marquee: [
      "Centre-back",
      "Defensive midfielder",
      "Deportes Antofagasta",
      "Chile",
      "23 years old",
      "1.86 m",
    ],
    profile: {
      eyebrow: "01 · Profile",
      title: "Profile",
      description:
        "A defender with experience in Chilean professional football, able to defend the box and read play early, with the versatility to operate in front of the back line.",
      facts: {
        age: "Age",
        nationality: "Nationality",
        height: "Height",
        foot: "Preferred foot",
        positions: "Positions",
        club: "Current club",
      },
      values: {
        age: "23 years old",
        nationality: "Chilean",
        height: "1.86 m",
        foot: "Right",
        positions: "Centre-back · Defensive midfielder",
        club: "Deportes Antofagasta",
      },
    },
    stats: {
      eyebrow: "02 · Stats",
      title: "2026 Statistics",
      matches: "Appearances",
      minutes: "Minutes",
      goals: "Goals",
      interceptions: "Interceptions",
      blockedShots: "Blocked shots",
      defenseTitle: "Defensive record · 2026 League",
      speedTitle: "Top in-match speed",
      speedValue: "34+ km/h",
      agencyBadge: "Reported by representation",
      tableTitle: "Breakdown by competition",
      table: {
        competition: "Competition",
        season: "Season",
        matches: "Apps",
        minutes: "Min",
        goals: "Goals",
        total: "2026 total",
        noData: "—",
      },
      careerLabel: "Professional career at Deportes Antofagasta (all competitions · Transfermarkt, 12/10/2026)",
      noteCutoff: "Cut-off date",
      noteSource: "Source",
      noteDisclaimer:
        "Appearances, minutes and goals as published by the source above; they may change after each matchday. Defensive metrics come from the representation's (IKONS) report and are shown with their own cut-off date.",
      noteLink: "View performance data",
    },
    analysis: {
      eyebrow: "03 · Analysis",
      title: "Profile analysis",
      recognitionLabel: "Recognition",
      recognitionTitle: "Best centre-back in Liga de Ascenso 2026",
      recognitionScore: "Rating",
      recognitionMinutes: "% of minutes",
      recognitionSource: "Source",
      recognitionPublished: "Published",
      recognitionView: "View full ranking",
      recognitionImgAlt:
        "Data Ficus Top 10 best centre-backs ranking for Liga de Ascenso Chile 2026, with Cristian Díaz in first place",
      factLabel: "Fact",
      viewLabel: "Assessment",
      items: [
        {
          title: "Versatility",
          tag: "Centre-back · Defensive mid",
          fact: "He competes as a centre-back and as a defensive midfielder.",
          view: "Two positions in a single player.",
        },
        {
          title: "Anticipation & interceptions",
          tag: "Game reading",
          fact: "38 interceptions and 13 blocked shots in the 2026 league (IKONS report, June 2026 cut-off). Sofascore lists ball interception and positioning as strengths of his profile.",
          view: "Cuts passing lanes and protects the box.",
        },
        {
          title: "Speed",
          tag: "34+ km/h",
          fact: "Top in-match speed above 34 km/h, as reported by his representation.",
          view: "Able to cover long distances in behind.",
        },
      ],
    },
    videos: {
      eyebrow: "04 · Videos",
      title: "Videos",
      play: "Play video",
      close: "Close video",
      note: "Exclusive material. Videos can only be played within this site.",
    },
    gallery: {
      eyebrow: "05 · Gallery",
      title: "Gallery",
      note: "Match and training material. Captions will be added once the opponent, competition and date of each image are confirmed.",
    },
    market: {
      eyebrow: "06 · Market",
      title: "Valuation & market status",
      valueLabel: "Estimated market value",
      disclaimer:
        "Public Transfermarkt estimate; last indicated update: 22/06/2026. It is not an offer, a release clause or a transfer fee.",
      sourceLink: "View source on Transfermarkt",
      contractTitle: "Contract status",
      contract: "Contract until 31/12/2026",
      freeAgent: "Free agent from January 2027",
    },
    contact: {
      eyebrow: "07 · Contact",
      title: "Professional contact",
      lead: "Enquiries from clubs, sporting directors, coaches and scouts. Representation: IKONS.",
      directLabel: "IKONS direct contact",
      formTitle: "Send an enquiry",
      name: "Name",
      club: "Club",
      role: "Role",
      email: "Email",
      message: "Message",
      namePh: "Full name",
      clubPh: "Club or organisation",
      rolePh: "Sporting director, scout, coach…",
      emailPh: "name@club.com",
      messagePh: "Write your professional enquiry",
      submit: "Send message",
      sending: "Sending…",
      success: "Message sent. IKONS will reply as soon as possible.",
      error: "Could not send. Please try again or use the direct email.",
    },
    footer: {
      managed:
        "Site managed by IKONS · Representation of Cristián Antonio Díaz Ferrada",
      updated: "Updated",
      rights: "Content for professional use.",
    },
  },
};
